// App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Typography from '@mui/material/Typography';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaidIcon from '@mui/icons-material/Paid';
import PixIcon from '@mui/icons-material/Pix';
import AddCardIcon from '@mui/icons-material/AddCard';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CelebrationIcon from '@mui/icons-material/Celebration';
//import Menu from './Menu';
import GrassIcon from '@mui/icons-material/Grass';
import Home1 from './components/pages/Home1'; // Import without curly braces
import Home from './components/pages/Home'; // Import without curly braces
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import HubIcon from '@mui/icons-material/Hub';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import WaterDamageIcon from '@mui/icons-material/WaterDamage';
import BusinessAssociatesIndex from './components/pages/BusinessAssociates/BusinessAssociatesIndex';
import StoreIcon from '@mui/icons-material/Store';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import PersonIcon from '@mui/icons-material/Person';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import TimelineSharpIcon from '@mui/icons-material/TimelineSharp';
import ViewTimelineSharpIcon from '@mui/icons-material/ViewTimelineSharp';
import Home2 from './components/pages/Home2'; // Import without curly braces

import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import SessionTimeout from "./SessionTimeout";

//Adminstartion 
import AdministrationIndex from "./components/pages/Administartion/Index";
import AdministrationDetail from "./components/pages/Administartion/Details";

import MemberIndex from "./components/pages/Member/MemberIndex";
import MemberCreate from "./components/pages/Member/create";
import MemberEdit from "./components/pages/Member/medit";
import EventIndex from "./components/pages/Events/index";
import EventCreate from "./components/pages/Events/create";
import EventEdit from "./components/pages/Events/edit";
import CIndex from "./components/pages/Company/index";
import CEdit from "./components/pages/Company/edit";
//import PoIndex from "./components/pages/Positions/Poindex";
import PositionIndex from "./components/pages/Positions/Poindex";
import FeesIndex from "./components/pages/ClubFees/index";
import GenerateFees from "./components/pages/ClubFees/GenerateFees";
import AssetIndex from "./components/pages/AssetRegistration/Aindex";
import AccountIndex from "./components/pages/AccountsRegistration/AccountIndex";

//Payment and Receipt
import PRIndex from "./components/pages/PaymentAndReceipt/PRIndex";
import PRCreate from "./components/pages/PaymentAndReceipt/PRCreate";
import PREdit from "./components/pages/PaymentAndReceipt/PREdit";
import PaymentAndReceiptEdit from "./components/pages/PaymentAndReceipt/Edit";
import PRCreateFromEvent from "./components/pages/PaymentAndReceipt/PRCreateFromEvent";
//Branch
import BIndex from "./components/pages/Branch/BIndex";
import BranchCreate from "./components/pages/Branch/BCreate";
import BranchEdit from "./components/pages/Branch/BEdit";
import Ledger from "./components/pages/Reports/Ledger";
//import CashBook from "./components/pages/Reports/CashBook";
import UserDescription from "./components/pages/Member/UserRoleSettings";
import ClubBudget from "./components/pages/Budget/ClubBudget";
import EventBudget from "./components/pages/Budget/EventBudget";
import RedeemIcon from '@mui/icons-material/Redeem';
import GroupIcon from '@mui/icons-material/Group';
import ReIndex from "./components/pages/View/Reminder";
import CashBook1 from "./components/pages/Reports/NewCashBook";
import Ledger1 from "./components/pages/Reports/NewLedger";
import BalanceSheet from "./components/pages/Reports/BalanceSheet";
import IncomeExpenseReport1 from "./components/pages/Reports/IncomeExpenseReport";
import PRReport from "./components/pages/Reports/PRReport";
import AccountparentGroups from "./components/pages/Nature/NatureIndex";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import WalletSharpIcon from '@mui/icons-material/WalletSharp';
import ParentGroupIndex from "./components/pages/ParentGroups/ParentGroupIndex";
import ClubAssociatesTypeIndex from "./components/pages/ClubAssociatesTypes/ClubAssociatesTypeIndex";

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [budgetOpen, setBudgetOpen] = useState(false);
  const [administrationOpen, setAdministrationOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [transactionOpen, setTransactionOpen] = useState(false);
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleUserClick = () => {
    setUserOpen(!userOpen);
  };
  const handleBudgetClick = () => {
    setBudgetOpen(!budgetOpen);
  };

  const handleAdministrationClick = () => {
    setAdministrationOpen(!administrationOpen);
  };
  const handleViewClick = () => {
    setViewOpen(!viewOpen);
  };
  const handleTransactionClick = () => {
    setTransactionOpen(!transactionOpen);
  };

  const { clubName, branchName, clubId, isSuperAdmin, superCompanyId, roleName, username } = useAuth();

  return (
    <Router>
      <AuthProvider>

        <AppBar position="static" style={{ backgroundColor: '#0e728c', height: '52px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>
            <IconButton edge="start" color='white' aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon style={{ color: 'white' }} />
            </IconButton>

            <Typography
              variant="h6"
              component="div"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                color: 'white'
              }}
            >
              {/* Left Section */}
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                {/* <Link
                  to="/Home1"
                  style={{
                    textDecoration: 'none',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                > */}
                {(roleName === 'SuperAdmin' || roleName === 'CompanyAdmin') && (
                  <Link to="/Home" style={{ textDecoration: 'none' }}>
                    <FiHome style={{ marginRight: '8px', color: 'white' }} />
                  </Link>
                )}

                {(roleName === 'Member') && (
                  <Link to="/Home1" style={{ textDecoration: 'none' }}>
                    <FiHome style={{ marginRight: '8px', color: 'white' }} />
                  </Link>
                )}

                {(roleName === 'Member') && (
                  <Link to="/Home1" style={{ textDecoration: 'none' }}>
                    <Typography
                      variant="h6"
                      className="dual-text"
                      component="div"
                      style={{ marginLeft: '10px', fontWeight: 'bolder', position: 'relative' }}
                    >
                      <span style={{ color: 'white', font: 'Verdana', fontSize: '16px', textTransform: 'uppercase' }}>{branchName}</span>
                    </Typography>
                  </Link>
                )}

                {(roleName === 'SuperAdmin' || roleName === 'CompanyAdmin') && (
                  <Link to="/Home" style={{ textDecoration: 'none' }}>
                    <Typography
                      variant="h6"
                      className="dual-text"
                      style={{
                        marginLeft: '10px',
                        fontWeight: 'bolder',
                        position: 'relative',
                        color: 'white',
                        fontFamily: 'monospace',
                        fontSize: '16px',
                        textTransform: 'uppercase'
                      }}
                    >
                      {branchName}
                    </Typography>
                  </Link>
                )}

                {/* {(roleName === 'Member') && (
                    <Link to="/Home1" style={{ textDecoration: 'none' }}>
                      <Typography
                        variant="h6"
                        className="dual-text"
                        style={{
                          marginLeft: '10px',
                          fontWeight: 'bolder',
                          position: 'relative',
                          color: 'white',
                          fontFamily: 'Verdana',
                        }}
                      >
                        {clubName}
                      </Typography>
                    </Link>
                  )} */}


                {/* </Link> */}
              </div>

              {/* Right Section */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Typography
                  component="div"
                  style={{
                    fontWeight: 'bolder',
                    color: '#white',
                    fontFamily: 'monospace',
                    fontSize: '14px'
                  }}
                >
                  <PersonIcon /> {username}
                </Typography>
                <div className="white-icon" style={{ marginTop: '5px' }}>
                  <Logout style={{ backgroundColor: 'white' }} />
                </div>

              </div>
            </Typography>

          </Toolbar>
        </AppBar>

        {(
          <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
            <List>
              {(roleName === 'SuperAdmin' || roleName === 'CompanyAdmin') && (
                <>
                  <h6 style={{ textAlign: 'center', textTransform: 'uppercase', color: ' #7D0A0A', fontWeight: 'bolder', fontFamily: 'monospace' }}>{clubName}</h6>

                  {/* <ListItem button component={NavLink} to="/Home1" activeClassName="selected" onClick={handleDrawerClose}>
                    <ListItemText primary="HOME" style={{ color: 'black' }} />
                  </ListItem> */}

                  <ListItem button onClick={handleMasterClick} style={{ height: '40px' }}>
                    <h6 className='productHead flex-grow linkcolor'
                      style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}><ListItemText primary="MASTER" /></h6>
                    {masterOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>

                  <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                    <List style={{ paddingLeft: '16px' }}>


                      {/*<ListItem button component={NavLink} to="/CIndex" activeClassName="selected" onClick={handleDrawerClose}>
                        <AccountBalanceIcon style={{ color: 'red' }} />
                        <ListItemText primary="Club" />
                      </ListItem> */}
                      <ListItem button component={NavLink} to="/BIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <StoreIcon style={{ color: '#D37676', height: '20px' }} /><ListItemText primary="Club" style={{ color: 'black' }} />
                      </ListItem>
                      <ListItem button component={NavLink} to="/BusinessAssociatesIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <PeopleAltIcon style={{ color: 'black', height: '20px' }} /> <ListItemText primary="Business Associates" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/PositionIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <AdminPanelSettingsIcon style={{ color: 'teal', height: '20px' }} /> <ListItemText primary="Position" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/AccountparentGroups" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <GroupWorkIcon style={{ color: '#441752', height: '20px' }} /> <ListItemText primary="Nature" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/FeesIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <PaidIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Club Fees" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/GenerateFees" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <AttachMoneyIcon style={{ color: '#034C53', height: '20px' }} /><ListItemText primary="Generate Fees" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/AssetIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <PixIcon style={{ color: '#433878', height: '20px' }} /> <ListItemText primary="Asset Registration" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/AccountIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <AccountBalanceWalletIcon style={{ color: '#821131', height: '20px' }} /><ListItemText primary="Accounts Registration" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/ParentGroupIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <HubIcon style={{ color: '#441752', height: '20px' }} /><ListItemText primary="Parent Group" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/ClubAssociatesTypeIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <AddCardIcon style={{ color: '#821131', height: '20px' }} /><ListItemText primary="Club Associates Types" style={{ color: 'black' }} />
                      </ListItem>

                    </List>
                  </Collapse>

                  <ListItem button onClick={handleUserClick} style={{ height: '40px' }}>
                    <ListItemText primary="REGISTRATION" style={{ color: 'black' }} />
                    {userOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>

                  <Collapse in={userOpen} timeout="auto" unmountOnExit>
                    <List style={{ paddingLeft: '10px' }}>
                      <ListItem button component={NavLink} to="/MemberIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <PersonAddIcon style={{ color: '#D37676', height: '20px' }} /><ListItemText primary="Member" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/EventIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <Diversity3Icon style={{ color: '#0D7C66', height: '20px' }} /> <ListItemText primary="Events" style={{ color: 'black' }} />
                      </ListItem>
                    </List>
                  </Collapse>

                  <ListItem button onClick={handleBudgetClick} style={{ height: '40px' }}>
                    <ListItemText primary="BUDGETS" style={{ color: 'black' }} />
                    {budgetOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={budgetOpen} timeout="auto" unmountOnExit>
                    <List style={{ paddingLeft: '10px' }}>
                      <ListItem button component={NavLink} to="/CBIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <MonetizationOnIcon style={{ color: '#D37676', height: '20px' }} /><ListItemText primary="Club Budget" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/EBIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <PaidOutlinedIcon style={{ color: 'goldenrod', height: '20px' }} /> <ListItemText primary="Event Budget" style={{ color: 'black' }} />
                      </ListItem>
                    </List>
                  </Collapse>

                  <ListItem button onClick={handleReportClick} style={{ height: '40px' }}>
                    <ListItemText primary="REPORTS" style={{ color: 'black' }} />
                    {reportOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={reportOpen} timeout="auto" unmountOnExit>
                    <List style={{ paddingLeft: '10px' }}>

                      <ListItem button component={NavLink} to="/CashBook1" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <RedeemIcon style={{ color: '#6C946F', height: '20px' }} /><ListItemText primary="Cash Book" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/IncomeExpenseReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <TimelineSharpIcon style={{ color: 'goldenrod', height: '20px' }} /> <ListItemText primary="Income Expense" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/PRReport1" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <WalletSharpIcon style={{ color: '#A0937D', height: '20px' }} /> <ListItemText primary="Payment And Receipt" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/BalanceSheet" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <ViewTimelineSharpIcon style={{ color: '#7ABA78', height: '20px' }} /> <ListItemText primary="Balance Sheet" style={{ color: 'black' }} />
                      </ListItem>

                      <ListItem button component={NavLink} to="/Ledger1" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                        <GroupIcon style={{ color: '#AF8260', height: '20px' }} /> <ListItemText primary="Ledger" style={{ color: 'black' }} />
                      </ListItem>
                    </List>
                  </Collapse>
                </>
              )}


              {(roleName === 'SuperAdmin' || roleName === 'CompanyAdmin') && (
                <>
                  <ListItem button onClick={handleAdministrationClick} style={{ height: '40px' }}>
                    <h6 className='productHead flex-grow linkcolor'
                      style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> <ListItemText primary="ADMINISTRATION" /></h6>
                    {administrationOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={administrationOpen} timeout="auto" unmountOnExit>
                    <ListItem button component={NavLink} to="/AdministrationIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                      <AccountCircleIcon style={{ color: 'teal', height: '20px' }} />  <ListItemText primary="User" style={{ color: 'black' }} />
                    </ListItem>
                  </Collapse>

                  <ListItem button onClick={handleViewClick} style={{ height: '40px' }}>
                    <h6 className='productHead flex-grow linkcolor'
                      style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}><ListItemText primary="VIEW" /></h6>
                    {viewOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>

                  <Collapse in={viewOpen} timeout="auto" unmountOnExit>
                    <ListItem button component={NavLink} to="/ReIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                      <CircleNotificationsIcon style={{ color: 'red', height: '20px' }} />  <ListItemText primary="Reminder" style={{ color: 'black' }} />
                    </ListItem>
                  </Collapse>

                  <ListItem button onClick={handleTransactionClick} style={{ height: '40px' }}>
                    <h6 className='productHead flex-grow linkcolor'
                      style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> <ListItemText primary="TRANSACTION" /></h6>
                    {transactionOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={transactionOpen} timeout="auto" unmountOnExit>
                    <ListItem button component={NavLink} to="/PRIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                      <PaymentIcon style={{ color: '#49243E', height: '20px' }} /><ListItemText primary="Payments & Receipts" style={{ color: 'black' }} />
                    </ListItem>
                  </Collapse>
                </>
              )}
            </List>
          </Drawer>
        )}
        <Switch>
          {roleName === 'SuperAdmin' || roleName === 'CompanyAdmin' ? (
            <>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />
              <Route path="/Home2" exact component={Home2} />
              {/* Person */}
              <Route path="/BusinessAssociatesIndex" component={BusinessAssociatesIndex} />


              {/* VehicleClass */}



              <Route path="/MemberIndex" component={MemberIndex} />
              <Route path="/MemberCreate" component={MemberCreate} />
              <Route path="/MemberEdit/:id" component={MemberEdit} />
              <Route path="/UserDescription/:id" component={UserDescription} />


              <Route path="/EventIndex" component={EventIndex} />
              <Route path="/EventCreate" component={EventCreate} />
              <Route path="/EventEdit/:id" component={EventEdit} />
              {/* Company */}
              <Route path="/CIndex" component={CIndex} />
              <Route path="/ClubEdit/:id" component={CEdit} />
              {/* Position */}
              <Route path="/PositionIndex" component={PositionIndex} />
              {/* Club Fees */}
              <Route path="/FeesIndex" component={FeesIndex} />
              <Route path="/GenerateFees" component={GenerateFees} />
              <Route path="/AssetIndex" component={AssetIndex} />

              <Route path="/AccountIndex" component={AccountIndex} />
              <Route path="/ParentGroupIndex" component={ParentGroupIndex} />
              <Route path="/ClubAssociatesTypeIndex" component={ClubAssociatesTypeIndex} />

              <Route path="/PRIndex" component={PRIndex} />
              <Route path="/PRCreate" component={PRCreate} />
              <Route path="/PREdit/:id/:eventidnewid" component={PREdit} />
              <Route path="/PaymentAndReceiptEdit/:id/:eventidnewid/:from" component={PaymentAndReceiptEdit} />
              <Route path="/PRCreateFromEvent/:id" component={PRCreateFromEvent} />
              <Route path="/AccountparentGroups" component={AccountparentGroups} />

              <Route path="/BIndex" component={BIndex} />
              <Route path="/BranchCreate" component={BranchCreate} />
              <Route path="/BranchEdit/:id" component={BranchEdit} />
              {/*<Route path="/PREdit/:id" component={PREdit} />*/}

              <Route path="/LedgerIndex" component={Ledger} />
              {/* <Route path="/CashIndex" component={CashBook} /> */}
              <Route path="/CashBook1" component={CashBook1} />
              <Route path="/Ledger1" component={Ledger1} />
              <Route path="/IncomeExpenseReport" component={IncomeExpenseReport1} />
              <Route path="/PRReport1" component={PRReport} />
              <Route path="/BalanceSheet" component={BalanceSheet} />
              <Route path="/CBIndex" component={ClubBudget} />
              <Route path="/EBIndex" component={EventBudget} />
              {/* Administration */}
              <Route path="/AdministrationIndex" component={AdministrationIndex} />
              <Route path="/AdministrationDetail/:id" component={AdministrationDetail} />

              <Route path="/ReIndex" component={ReIndex} />
            </>
          ) : (
            <>
              {/* Fallback for other roles */}
              <Route path="/" exact component={Home1} />
              <Route path="/Home1" exact component={Home1} />

              {/* Person */}
              <Route path="/BusinessAssociatesIndex" component={BusinessAssociatesIndex} />

              {/* VehicleClass */}
              <Route path="/MemberIndex" component={MemberIndex} />
              <Route path="/MemberCreate" component={MemberCreate} />
              <Route path="/MemberEdit/:id" component={MemberEdit} />
              <Route path="/UserDescription/:id" component={UserDescription} />


              <Route path="/EventIndex" component={EventIndex} />
              <Route path="/EventCreate" component={EventCreate} />
              <Route path="/EventEdit/:id" component={EventEdit} />
              {/* Company */}
              <Route path="/CIndex" component={CIndex} />
              <Route path="/ClubEdit/:id" component={CEdit} />
              {/* Position */}
              <Route path="/PositionIndex" component={PositionIndex} />
              {/* Club Fees */}
              <Route path="/FeesIndex" component={FeesIndex} />
              <Route path="/GenerateFees" component={GenerateFees} />
              <Route path="/AssetIndex" component={AssetIndex} />

              <Route path="/AccountIndex" component={AccountIndex} />
              <Route path="/ParentGroupIndex" component={ParentGroupIndex} />
              <Route path="/ClubAssociatesTypeIndex" component={ClubAssociatesTypeIndex} />

              <Route path="/PRIndex" component={PRIndex} />
              <Route path="/PRCreate" component={PRCreate} />
              <Route path="/PREdit/:id/:eventidnewid" component={PREdit} />
              <Route path="/PaymentAndReceiptEdit/:id/:eventidnewid/:from" component={PaymentAndReceiptEdit} />
              <Route path="/PRCreateFromEvent/:id" component={PRCreateFromEvent} />



              <Route path="/AccountparentGroups" component={AccountparentGroups} />

              <Route path="/BIndex" component={BIndex} />
              <Route path="/BranchCreate" component={BranchCreate} />
              <Route path="/BranchEdit/:id" component={BranchEdit} />
              {/*<Route path="/PREdit/:id" component={PREdit} />*/}

              <Route path="/LedgerIndex" component={Ledger} />
              {/* <Route path="/CashIndex" component={CashBook} /> */}
              <Route path="/CashBook1" component={CashBook1} />
              <Route path="/Ledger1" component={Ledger1} />
              <Route path="/IncomeExpenseReport" component={IncomeExpenseReport1} />
              <Route path="/PRReport1" component={PRReport} />
              <Route path="/BalanceSheet" component={BalanceSheet} />
              <Route path="/CBIndex" component={ClubBudget} />
              <Route path="/EBIndex" component={EventBudget} />
              {/* Administration */}
              <Route path="/AdministrationIndex" component={AdministrationIndex} />
              <Route path="/AdministrationDetail/:id" component={AdministrationDetail} />

              <Route path="/ReIndex" component={ReIndex} />
            </>
          )}

          {/* Vehicle */}



        </Switch>
      </AuthProvider>
    </Router >
  );
};

export default App;
